<template>
    <div>
        <h2 class="mt-2 mb-6 text-center font-roboto text-display-sm font-bold tracking-[-0.5px] text-black">
            Consumer Product Testing Platform for Better Product Decisions
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <SolutionCard
                v-for="(solution, i) in solutions.slice(0, 2)"
                :key="i"
                class="block h-auto"
                :solution="solution"
                :to="solution.uri"
                :is-vertical="true"
            />
        </div>

        <div class="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-3">
            <SolutionCard
                v-for="(solution, i) in solutions.slice(2, 5)"
                :key="i"
                class="block h-full"
                :solution="solution"
                :to="solution.uri"
                :is-vertical="true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import SolutionCard from '~/components/common/empower/empower-card'

interface DecisionSolution {
    image: string
    title: string
    description: string
    uri: string
}

const solutions: DecisionSolution[] = [
    {
        image: 'arts/Retarget.svg',
        title: 'Validate Product-Market Fit',
        description: 'Find out whether your product meets a consumer need before investing heavily in production. Forecast demand, measure product appeal and purchase intent, and evaluate product fit with consumers who represent your target audience.',
        uri: '',
    },
    {
        image: 'arts/Speed.svg',
        title: 'Identify Key Product Drivers',
        description: 'Find out which product attributes matter most to consumers. Understand what makes one option more appealing than another. Use structured consumer feedback to identify the features, benefits, and experiences that influence consumer preference. Identify the areas that require future improvement.',
        uri: '',
    },
    {
        image: 'arts/Pictogram-2.svg',
        title: 'Understand Consumer Perceptions',
        description: 'Learn how consumers perceive your product, brand, and overall value proposition. Identify the associations, expectations, and emotional responses that influence how your product is evaluated and whether it stands out in the market.',
        uri: '',
    },
    {
        image: 'arts/Research.svg',
        title: 'Benchmark Against Alternatives',
        description: 'Compare how consumers view your product compared with other options available to them. Identify the strengths that make your product stand out and areas where competitors may have an advantage.',
        uri: '',
    },
    {
        image: 'arts/Pictogram-lg.svg',
        title: 'Support Decisions With Consumer Data',
        description: 'Use accurate consumer data to make informed decisions. Combine quantitative and qualitative feedback to replace assumptions with evidence. Use what you learn to decide what to improve, change, or take forward.',
        uri: '',
    },
]
</script>
